import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ClientsList from './pages/ClientsList';
import ClientDetails from './pages/ClientDetails';
import DirectorManagement from './pages/DirectorManagement';
import GeotaggingPage from './pages/GeotaggingPage';
import SeoAudit from './pages/SeoAudit';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/clients" element={<PrivateRoute><ClientsList /></PrivateRoute>} />
            <Route path="/clients/:id" element={<PrivateRoute><ClientDetails /></PrivateRoute>} />
            <Route path="/directors" element={<PrivateRoute><DirectorManagement /></PrivateRoute>} />
            <Route path="/geotagging" element={<PrivateRoute><GeotaggingPage /></PrivateRoute>} />
            <Route path="/seo-audit" element={<PrivateRoute><SeoAudit /></PrivateRoute>} />
            <Route path="/" element={<Navigate to="/clients" replace />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;